<template>
  <div>
    <div v-if="isErpdActive" class="ecl-message ecl-message--info ml-3 mb-3">
      <div class="d-lg-flex d-none align-items-baseline justify-conten-center">
        <svg class="ecl-icon ecl-icon--l ecl-message__icon" focusable="false" aria-hidden="true">
          <use xlink:href="@/assets/img/ecl/icons.svg#information"></use>
        </svg>
      </div>
      <!-- https://gitlab.fokus.fraunhofer.de/piveau/organisation/piveau-scrum-board/-/issues/3341 -->
      <div v-html="$t('message.datasetFacets.facets.erpdInfo')"></div>
    </div>
    <div v-if="isHVDActive" class="ecl-message ecl-message--info ml-3 mb-3">
      <div class="d-lg-flex d-none align-items-baseline justify-conten-center">
        <svg class="ecl-icon ecl-icon--l ecl-message__icon" focusable="false" aria-hidden="true">
          <use xlink:href="@/assets/img/ecl/icons.svg#information"></use>
        </svg>
      </div>
      <!-- https://gitlab.fokus.fraunhofer.de/piveau/organisation/piveau-scrum-board/-/issues/3466 -->
      <div v-html="$t('message.datasetFacets.facets.hvdInfo')"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DatasetListInfos",
  computed: {
    isErpdActive() {
      return this.$route.query.superCatalog === 'erpd'
        || this.$route.path === '/catalogues/erpd';
    },
    isHVDActive() {
      return this.$route.query.is_hvd === 'true';
    }
  }
}
</script>
